import React, { useEffect } from 'react'
import Nav from '../../components/nav/Nav'
import Sketches from '../../components/sketches/Sketches';
import BotDiv from '../../components/botdiv/BotDiv'
import Loader from '../../components/preloader/Loader';

function AllSketches({ loaderFinished, setLoaderFinished }) {
  useEffect(()=>{
    setLoaderFinished(false);
  },[setLoaderFinished]);

  return (
    <div className='allSketches'>
        <Loader loaderFinished={setLoaderFinished} data="sketches" show2={false}/>
        {loaderFinished && (
          <>
            <Nav inHome={false}/>
            <Sketches showAllSketch={true}/>
            <BotDiv/>
          </>
        )}
    </div>
  )
}

export default AllSketches